/**
 * The mission-focus prop can arrive while SprintDetail is still showing the
 * campaign we're leaving. Its tasks are loaded, so a mission that lives in
 * the destination looks missing and the focus is thrown away.
 *
 * 'defer' — wait until this campaign is on screen and its tasks are loaded.
 * 'found' / 'missing' — safe to pan or to report it gone.
 * 'idle' — no mission was requested.
 */
export function missionFocusGate({
  missionId,
  tasks,
  localCampaignId,
  targetCampaignId,
}) {
  if (!missionId) return 'idle';
  if (
    targetCampaignId &&
    localCampaignId &&
    targetCampaignId !== localCampaignId
  ) {
    return 'defer';
  }
  // Empty or not-yet-loaded tasks must not count as "handled". A new tab
  // selects the campaign before its missions arrive; treating that as idle
  // dropped the focus and the campaign opened without centering the mission.
  if (!Array.isArray(tasks) || tasks.length === 0) return 'defer';
  return tasks.some((task) => task.id === missionId) ? 'found' : 'missing';
}
